import { cn } from '@parcel/ui';
import type { ReactNode } from 'react';
import type { ApiContactRole } from '../../lib/contacts.js';
import { BadgeOverflowList } from '../data-table/badge-overflow.js';

export type ContactRole = ApiContactRole;

type ContactRoleVariant = 'amber' | 'blue' | 'green' | 'gray' | 'purple';

export const CONTACT_ROLE_META: Record<
  ContactRole,
  { label: string; variant: ContactRoleVariant }
> = {
  developer_contact: { label: 'Developer contact', variant: 'blue' },
  architect_contact: { label: 'Architect contact', variant: 'purple' },
  engineer_contact: { label: 'Engineer contact', variant: 'amber' },
  gc_contact: { label: 'GC contact', variant: 'green' },
  agency_pm: { label: 'Agency PM', variant: 'gray' },
  attorney: { label: 'Attorney', variant: 'gray' },
  owner_contact: { label: 'Owner contact', variant: 'gray' },
  other: { label: 'Other', variant: 'gray' },
};

export function getContactRoleMeta(role: ContactRole) {
  return CONTACT_ROLE_META[role];
}

interface ContactRoleBadgesProps {
  roles: readonly ContactRole[];
  /** Badges shown before collapsing into "+N"; defaults to all (drawer lists). */
  maxVisible?: number;
  empty?: ReactNode;
  className?: string;
  badgeClassName?: string;
}

export function ContactRoleBadges({
  roles,
  maxVisible = Number.POSITIVE_INFINITY,
  empty = <span className="text-sm text-muted-foreground">—</span>,
  className,
  badgeClassName,
}: ContactRoleBadgesProps) {
  return (
    <BadgeOverflowList
      items={roles.map((role) => {
        const meta = getContactRoleMeta(role);
        return { key: role, label: meta.label, variant: meta.variant };
      })}
      maxVisible={maxVisible}
      empty={empty}
      className={cn('flex-wrap gap-1.5', className)}
      badgeClassName={badgeClassName}
    />
  );
}
